import { TemplateElement, html, defineElement, optionalAttribute } from '@webtides/element-js';
import style from './button-bar.css';
import '../../../button/button.js';

/**
 * @property {LinkProperties[]} links - Links
 */
export default class ButtonBar extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            links: [],
        };
    }

    template() {
        return html`
            <div class="flex flex-wrap justify-center gap-fix-s">
                ${this.links.map(
                    (link, index) => html`
                        <mb-button
                            href="${link.url}"
                            variant="${link.variant || index === 0 ? 'primary' : 'secondary'}"
                            ${optionalAttribute(link.type === 'external', 'target', '_blank')}
                            element="button bar"
                        >
                            ${link.text}
                        </mb-button>
                    `,
                )}
            </div>
        `;
    }
}

defineElement('mb-button-bar', ButtonBar);
